module.exports = __webpack_public_path__ + "static/media/iconfinder_whatsapp_115679.0776e532.svg";